import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./Theme";
import toast, { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import { ToastProvider } from "./Components/ToastProvider";

export default function App() {
  return (
    <>
      <HelmetProvider>
        <Toaster />
        <ThemeProvider theme={theme}>
          <ToastProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </ToastProvider>
        </ThemeProvider>
      </HelmetProvider>
    </>
  );
}
